import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ItemDetails from '../fragments/ItemDetails'
import { DataTable } from 'components/DataTable/'
import { ContentBlock } from 'components/ContentBlock'
import { availability_intervals } from '../../../tableColumns'
import { Form } from 'components/forms'
import updateProperties from '../../../fragments/mutateProductProperties'
import { updateProductProperties } from '../../../gql/mutation'
import getProduct from '../../../gql/query/getProduct'
import { useMutation } from 'components/graphql'

const Sale = ({ data = {}, formData = {}, itemId, mutations: { updateItem }, blockId, expandedId }) => {
	const [t] = useTranslation()

	const [selectedItem, setSelectedItem] = useState(null)
	const [mutate] = useMutation(updateProductProperties)

	const handleChangeDetails = vals => {
		updateItem({ intervals: vals }, { refetchQueries: [{ query: getProduct, variables: { id: data.id } }] })
		if(!vals.id || vals.id === -1) {
			hideDetails()
		}
	}
	const hideDetails = () => setSelectedItem(null)
	const filteredIntervals = Array.isArray(data.intervals) ? data.intervals.filter(({ type }) => type === 0) : []
	return(
		<>
			<Form
				initialValues={formData}
				onSubmit={({ properties }) => updateProperties({ productId: data.id, ...properties }, mutate)}
				smartSubmit
			>
				<ContentBlock startExpanded label={t('product_section.strings.sale')} blockId={blockId}>
					<DataTable
						data={filteredIntervals}
						columns={availability_intervals(t)}
						withSearch
						selectRow
						sortable={false}
						onRowClick={(state, { original }) => setSelectedItem(original)}
						mutateRow={{
							onRowMutate: id => {
								handleChangeDetails({ id })
								if(selectedItem && selectedItem.id === id) {
									hideDetails()
								}
							}
						}}
						onAddRecord={() => setSelectedItem({})}
					/>
				</ContentBlock>
			</Form>
			<ItemDetails
				key={selectedItem ? selectedItem.id : -1}
				data={selectedItem}
				itemType={0}
				isParentExpanded={expandedId === blockId}
				onDataChange={handleChangeDetails} />
		</>
	)
}

export default Sale
